export default __webpack_public_path__ + "media/images/wordmark-white-text-claire-c3a6d859dc6c85c80343b38aa16da558.svg";